{
  "facility": {
    "facilityList": "Facility List",
    "facilityActions": "Facility Actions",
    "addFacility": "Add Facility",
    "retireFacilities": "Retire Facilities",
    "deleteFacilities": "Delete Facilities",
    "searchByAddress": "Search by address",
    "filterFacilities": "Filter Facilities",
    "activityStatus": "Activity Status",
    "facilityInfo": "Facility Information",
    "chooseProgram": "Choose...",
    "utility": "FSE Utility",
    "assetOverview": "Asset Overview",
    "chooseUtility": "Choose...",
    "noPrograms": "No Programs are registered for this {{regionType}}.",
    "chooseProgramHelp": "Choose a {{regionType}} and first reporting period to see Programs.",
    "chooseUtilityHelp": "Choose a state to see available Utilities.",
    "noUtilities": "No Utilities found.",
    "retireFacility": "Retire Facility",
    "deleteFacility": "Delete Facility",
    "assetList": "Asset List",
    "retireWarning": "Warning: Retiring this Facility will retire all its Equipment, and any Equipment Usage data",
    "retireWarningEnd": "will be discarded.",
    "retireConfirmation1": "I understand that retiring this Facility will also retire all its Equipment.",
    "retireConfirmation2Start": "I understand that all usage data",
    "retireConfirmation2End": "will be discarded.",
    "retireMultipleConfirmation_one": "I understand that {{count}} selected facility will be retired along with all of its equipment.",
    "retireMultipleConfirmation_other": "I understand that {{count}} selected facilities will be retired along with all of their equipment.",
    "deleteMultipleConfirmation_one": "I understand that {{count}} selected facility will be permanently deleted and this cannot be undone.",
    "deleteMultipleConfirmation_other": "I understand that {{count}} selected facilities will be permanently deleted and this cannot be undone."
  }
}
